import { Injectable } from '@angular/core';
import { AppSnackbarService } from './app-snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorToastService {

  constructor(private snackbarService: AppSnackbarService) { }

  showErrorWithDetails(title: string, message: string): void {
    this.snackbarService.open(title, message, 8000);
  }

  showError(message: string): void {
    this.snackbarService.open('Error', message, 5000);
  }
}
